module.exports = __webpack_public_path__ + "img/20191118160754191.ded32362.jpg";